import { safeDestroys } from '@Common/Core/Destroyable';
import { BaseControl, IControlParameters } from './BaseControl';

export interface IStackPanelItem {
    control: any;
    css?: any;
    className?: string;
}

export interface IStackPanelParameters extends IControlParameters {
    isVertical?: boolean;
}

export class StackPanel extends BaseControl {
    private _ul: any;
    private _items: any[];

    constructor(param?: IStackPanelParameters) {
        super(
            $.extend(
                {
                    css: null,
                    className: '',
                    width: '100%',
                    height: '100%',

                    isVertical: true
                },
                param
            )
        );

        this._ul = null;
        this._items = [];
        this._init();
    }

    protected _init() {
        this._root = $('<div class="stack-panel"/>');
        this._ul = $('<ul/>').appendTo(this._root);
        this._root.addClass(this._param.isVertical == true ? 'vertical' : 'horizontal');
        this._applyDefaultParam();
    }

    public items(items) {
        this._ul && this._ul.empty();
        this._items = items;
        if (!this._items || !this._items.length) {
            return;
        }

        _(this._items).forEach(
            function (item, index) {
                let control = item.control;
                // controls
                if (control.getControl) {
                    control = control.getControl();
                }

                const li = $('<li/>').append(control).appendTo(this._ul);

                item.className && li.addClass(item.className);
                item.css && li.css(item.css);
            }.bind(this)
        );
    }

    public enabled(data) {
        _(this._items).forEach(function (item) {
            item.control.enabled && item.control.enabled(data);
        });

        return super.enabled(data);
    }

    public readonly(data): boolean {
        _(this._items).forEach(function (item) {
            item.control.readonly && item.control.readonly(data);
        });
        return super.readonly(data);
    }

    public destroy(): void {
        _(this._items).forEach(item => safeDestroys(item.control));
        super.destroy();
    }

    public adjust(width?: number, height?: number) {
        this._root.outerWidth(width ? width : 'auto');
        this._root.outerHeight(height ? height : 'auto');

        _(this._items).forEach(
            function (item) {
                if (item.control.adjust) {
                    if (this._items.length == 1) {
                        item.control.adjust(width, height);
                    } else {
                        item.control.adjust();
                    }
                }
            }.bind(this)
        );
    }
}
